import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const SettingsContext = createContext({ settings: null, refresh: () => {}, loading: false });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/settings');
      setSettings(data);
    } catch (e) {
      console.error('Failed to load settings', e);
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  return <SettingsContext.Provider value={{ settings, refresh, loading }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
